import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class AuthService implements CanActivate {

    public accessibleNetPrices = false;
    public accessiblePayerView = false;
    public accessibleReimbursement = false;
    public accessibleTreatmentCost = false;
    public accessibleViewMap = false;
    public loggedInUser = '';
    public isTestUser;
    public homeUrl = 'http://www.akceso.pro/tools/web/get-resources-eIRP-overview_testing3.php';
    private logoReceivedSubject = new Subject<string>();
    private loginSubject = new Subject();
    private userInfoReceived = new Subject<boolean>();

    constructor(private http: HttpClient) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        const that = this;
        let user = localStorage.getItem('verity_user');
        let token = localStorage.getItem('verity_token');

        if (route.params['user'] && route.params['token']) {
            user = route.params['user'];
            token = route.params['token'];
        }

        if (user && token) {

            this.loggedInUser = user;

            localStorage.setItem('verity_user', user);
            localStorage.setItem('verity_token', token);

            return new Promise<boolean>((resolve, reject) => {
                that.http.post('checklogin/', { user: user, token: token })
                    .subscribe((result) => {
                        if (result['token'] === 'match') {
                            localStorage.setItem('company', result['company']);

                            this.logoReceivedSubject.next(result['company']);
                            this.accessibleNetPrices = result['access_to_net_prices'] === 'Y';
                            this.accessiblePayerView = result['access_to_payer_view'] === 'Y';
                            this.accessibleReimbursement = result['access_to_reimbursement'] === 'Y';
                            this.accessibleTreatmentCost = result['access_to_treatment_cost'] === 'Y';
                            this.accessibleViewMap = result['access_to_heatmap'] === 'Y';
                            this.isTestUser = result['user_type'] === 'testing';

                            this.userInfoReceived.next(this.isTestUser);

                            resolve(true);

                            this.loginSubject.next();
                        } else {
                            localStorage.removeItem('verity_user');
                            localStorage.removeItem('verity_token');
                            resolve(false);
                        }
                    }, (error) => {
                        localStorage.removeItem('verity_user');
                        localStorage.removeItem('verity_token');
                        window.open(this.homeUrl);
                    });
                resolve(true);
            });
        }
      window.open(this.homeUrl);
    }

    onLogoReceived(): Observable<string> {
        return this.logoReceivedSubject.asObservable();
    }

    onLogin(): Observable<any> {
      return this.loginSubject.asObservable();
    }

    isTestingUser(): Observable<boolean> {
        return this.userInfoReceived.asObservable();
    }

}
